module.exports = __webpack_public_path__ + "media/components/home/creative-path/img/find-your-path-vector-2efd95e9cb5077509c637097b16de42d.jpg";